export const domainReg = /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{2,}$/;
export const subdomainReg = /^[a-zA-Z0-9@$?¡\-_]+\.[a-zA-Z0-9@$?¡\-_]+\.[a-zA-Z0-9]{2,8}$/;
export const emailReg = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;
export const stringReg = /^.*$/;
export const stringSpaceReg = /^[\s\S]*$/;
export const emojiReg = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;
